module.exports = __webpack_public_path__ + "img/employees@2x.b4736d3.jpg";